(function(){
 function wireBooksLearn(){
   var target='/pages/books-learn';
   document.querySelectorAll('a').forEach(function(a){
     var t=(a.textContent||'').replace(/\s+/g,' ').trim().toUpperCase();
     var img=a.querySelector('img');
     var alt=img?(img.getAttribute('alt')||'').toUpperCase():'';
     if(t.indexOf('BOOKS / LEARN')>-1||t.indexOf('BOOKS + LEARN')>-1||t==='BOOKS / LEARN'||alt.indexOf('BOOKS / LEARN')>-1||alt.indexOf('BOOKS + LEARN')>-1){
       a.setAttribute('href',target);
       a.setAttribute('data-sm-books-learn','true');
     }
   });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wireBooksLearn);else wireBooksLearn();
 document.addEventListener('shopify:section:load',wireBooksLearn);
 setTimeout(wireBooksLearn,500);
})();